import { Toaster } from "components/notification/Toaster";
import { func_serviceHandling, isNumberValid, isStringTrimEmpty } from "functions";
import { useDispatch } from "react-redux";
import {
  getFullProductDetailList_failure,
  getFullProductDetailList_request,
  getFullProductDetailList_success,
  getLicenseProducts_failure,
  getLicenseProducts_request,
  getLicenseProducts_success,
  getBillingSetup_request,
  getBillingSetup_success,
  getBillingSetup_failure,
  addAccount_request,
  addAccount_success,
  addAccount_failure,
  getMissingProducts_request,
  getMissingProducts_success,
  getMissingProducts_failure,
} from "../slices/recursiveBillingSetup.slices";
import usePromiseInstance_authorization from "./config";

export default function useRecursiveBillingSetup() {
    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function getBillingSetup(pageNo, pageSize, sort, filterOptions) {
        dispatch(getBillingSetup_request());

        request(getBillingSetup_request, (axios) => {  
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;
    
            let paramObj = {
                offset,
                limit: pageSize,
                sort,
                ...filterOptions
            }
    
            let url = func_serviceHandling.createUrlWithParams('/BillingSetup/Search', paramObj)

            axios.get(url)
                .then((response) => {
                    dispatch(getBillingSetup_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load billing setup";
				    Toaster({ type: "error", msg });

                    dispatch(getBillingSetup_failure(msg));
                })
        })
    }

    function getFullProductDetailList() {
        dispatch(getFullProductDetailList_request());

        request(getFullProductDetailList_request, (axios) => {    
            axios.get('/BillingSetup/GetProductCodeNameV2')
                .then((response) => {
                    dispatch(getFullProductDetailList_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load product code details";
				    Toaster({ type: "error", msg });

                    dispatch(getFullProductDetailList_failure(msg));
                })
        })
    }

    function getLicenseProducts(productCode) {
        dispatch(getLicenseProducts_request());

        request(getLicenseProducts_request, (axios) => {  
            let productCode_validated = isStringTrimEmpty(productCode)? "productCode=" + productCode:"";

            axios.get('/BillingSetup/GetLicenseProducts?' + productCode_validated)
                .then((response) => {
                    dispatch(getLicenseProducts_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load license products";
				    Toaster({ type: "error", msg });

                    dispatch(getLicenseProducts_failure(msg));
                })
        })
    }

    function addAccount(accountInfo) {
        dispatch(addAccount_request());

        request(addAccount_request, (axios) => {    
            axios.post('/BillingSetup', JSON.stringify(accountInfo))
                .then((response) => {
                    dispatch(addAccount_success(response.data));
                    Toaster({
                        type: "success",
                        msg: "Successfully added billing setup(s)"
                    });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to add billing setup(s)";
				    Toaster({ type: "error", msg });

                    dispatch(addAccount_failure(msg));
                })
        })
    }

    function getMissingProducts(productCodeList) {
      dispatch(getMissingProducts_request());

      request(getMissingProducts_request, (axios) => {
        axios
          .post("/Report/GetMissingProducts", JSON.stringify(productCodeList))
          .then((response) => {
            dispatch(getMissingProducts_success(response.data));
          })
          .catch((error) => {
            let msg = error?.response?.data?.exceptionMessage
              ? error.response.data.exceptionMessage
              : "Failed to load Missing products";
            Toaster({ type: "error", msg });

            dispatch(getMissingProducts_failure(msg));
          });
      });
    }

    return {
      getBillingSetup,
      getFullProductDetailList,
      getLicenseProducts,

      addAccount,
      getMissingProducts,
    };
}